import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

// Inline SVG for a leaf icon (you can replace with an external icon library like Heroicons)
const LeafIcon = () => (
  <svg
    className="inline-block w-6 h-6 mr-1 fill-current text-green-500"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.31 0-6 2.69-6 6 0 1.66.67 3.17 1.76 4.24.28-.47.65-.89 1.08-1.24C8.31 10.47 8 9.76 8 9c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .76-.31 1.47-.84 2-.43.35-.8.77-1.08 1.24C15.33 11.17 16 9.66 16 8c0-3.31-2.69-6-6-6z" />
  </svg>
);

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Helper to check active route
  const isActive = (path) => location.pathname === path;

  // Navigation Links
  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Resources", path: "/resources" },
    { name: "Roadmaps", path: "/roadmaps" },
    { name: "Career Prep", path: "/cp" },
    { name: "Career Paths", path: "/career-paths" },
  ];

  return (
    <nav className="w-full px-4 py-3 bg-[#0A0F20] text-white sticky top-0 z-50 shadow-md">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-1 group">
          <div className="text-2xl sm:text-3xl font-semibold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-green-400 to-blue-500 group-hover:from-green-500 group-hover:to-blue-600 transition-all duration-300">
          
            GrowEasy
          </div>
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-6">
          <div className="flex items-center space-x-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                  isActive(link.path)
                    ? "bg-blue-600 text-white"
                    : "text-gray-300 hover:bg-gray-800 hover:text-white"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Buttons */}
          <div className="flex items-center space-x-4">
            <Link to="/community">
              <button className="px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-full text-sm font-medium transition duration-200">
                Join Our Community
              </button>
            </Link>
          </div>
        </div>

        {/* Mobile Hamburger Button */}
        <button
          className="md:hidden text-white hover:text-green-400 transition-colors duration-200"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="md:hidden mt-4 pb-4 bg-gray-900 rounded-xl overflow-hidden animate-fadeIn">
          <div className="flex flex-col gap-2 px-4 pt-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-5 py-3 text-center rounded-full text-sm font-medium transition-colors duration-200 ${
                  isActive(link.path)
                    ? "bg-blue-600 text-white"
                    : "text-gray-300 hover:bg-gray-800 hover:text-white"
                }`}
                onClick={() => setMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}

            {/* Additional buttons for mobile */}
            <Link to="/community">
              <button
                className="mt-3 w-full py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-full text-sm font-medium transition duration-200"
                onClick={() => setMenuOpen(false)}
              >
                Join Our Community
              </button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;